// @flow
import { fiveSymbolsMap } from '@site-builder/common/src/types/locale'
import React from 'react';

import type { FiveSymbolLocale } from '@site-builder/common/src/types/locale'

import svg from '../../../assets/images/icons/xsolla-badge.svg';
import { getXsollaLogoPoweredText, getXsollaLogoSbText } from '../../../utils/translation';

import './style.pcss';

type Props = {
  locale: FiveSymbolLocale
};

const XsollaLogo = ({ locale }: Props) => (
  <div className='ui-site-xsolla-logo'>
    <a
      className='ui-site-xsolla-logo__link'
      href='https://xsolla.com/products/site-builder?utm_source=sitebuilder&utm_medium=footer'
      target='_blank'
      rel='noopener noreferrer'
      dir="ltr"
    >
      <div
        className='ui-site-xsolla-logo__img'
        dangerouslySetInnerHTML={{ __html: svg }} // eslint-disable-line
      />
      <div className='ui-site-xsolla-logo__text'
      dir={fiveSymbolsMap[locale] === 'ar' ? 'rtl' : 'ltr'}>
        <span className='ui-site-xsolla-logo__powered-by'>
          {getXsollaLogoPoweredText(locale)}
        </span>
        <span className='ui-site-xsolla-logo__xsolla-sb'>
          {getXsollaLogoSbText(locale)}
        </span>
      </div>
    </a>
  </div>
);

export default XsollaLogo;
